import React from 'react';

import BellyBanner from './thumbnailTypes/BellyBanner';
import Circular from './thumbnailTypes/Circular';
import Horizontal from './thumbnailTypes/Horizontal';
import Plex from './thumbnailTypes/Plex';
import Upnext from './thumbnailTypes/Upnext';
import Vertical from './thumbnailTypes/Vertical';
import { ThumbnailComponentProps, ThumbnailTypes } from './types';
import { DynamicObject } from '../../utils/commonTypes';

const ThumbnailComponent: React.FC<ThumbnailComponentProps> = (props) => {
  const { thumbnailType } = props;

  const mapThumbnailTypeWithComponents: DynamicObject = {
    [ThumbnailTypes.vertical]: () => <Vertical {...props} />,
    [ThumbnailTypes.horizontal]: () => <Horizontal {...props} />,
    [ThumbnailTypes.upnext]: () => <Upnext {...props} />,
    [ThumbnailTypes.circular]: () => <Circular {...props} />,
    [ThumbnailTypes.bellybanner]: () => <BellyBanner {...props} />,
    [ThumbnailTypes.plex]: () => <Plex {...props} />,

    default: () => <Horizontal {...props} />
  };

  const renderThumbnailComponent = () => {
    if (mapThumbnailTypeWithComponents[thumbnailType]) {
      return mapThumbnailTypeWithComponents[thumbnailType]();
    }
    return mapThumbnailTypeWithComponents.default();
  };
  return <>{renderThumbnailComponent()}</>;
};

export default ThumbnailComponent;
